import { MessageResponseType } from './Message';
/*
 *
 * InteractiveArea reducer
 *
 */

import ActionTypes from './constants';
import ActionTypesCabinet from 'containers/Configurator/constants/furniture';
import { ContainerState } from './types';
import {
  Message,
  MessageLevel,
  MessageResponse,
} from 'containers/InteractiveArea/Message';
import properties from '../../helpers/config';

function initialsMessages() {
  let welcome = 'Bienvenue dans le configurateur de Kewlox';
  let response = 'Montrez-moi comment ça marche';

  const codeLg = properties.language;
  switch (codeLg) {
    case 'nl':
      welcome = 'Welkom bij de Kewlox-configurator';
      response = 'Laat me zien hoe het werkt.';
      break;
    case 'en':
      welcome = 'Welcome to the Kewlox configurator';
      response = 'Show me how it works.';
      break;
    case 'de':
      welcome = 'Willkommen beim Kewlox-Konfigurator';
      response = 'Zeigen Sie mir, wie es funktioniert.';
  }

  const responses: MessageResponse[] = [
    new MessageResponse(response, MessageResponseType.Tutorial),
  ];

  const welcomeMsg = new Message(welcome, MessageLevel.Info, responses);
  return [welcomeMsg];
}

export const initialState: ContainerState = {
  messages: initialsMessages(),
  isNew: false,
};

function interactiveAreaReducer(
  state: ContainerState = initialState,
  action: any,
): ContainerState {
  switch (action.type) {
    case ActionTypes.ADD_MESSAGE:
      return {
        ...state,
        messages: [action.payload.message],
        isNew: true,
      };
    case ActionTypesCabinet.CABINET_UPDATE_SUCCESS:
      if (!action.payload.preview && !state.isNew) {
        return {
          ...state,
          messages: [],
        };
      }
      return { ...state, isNew: false };
    case ActionTypes.FLUSH_MESSAGES:
      return { messages: [], isNew: false };
    default:
      return state;
  }
}

export default interactiveAreaReducer;
